<template>
    <div class="platformEvaluation">
        <van-nav-bar
            title="服务点评"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="content-box">
          <div class="content">
            <div class="content-top">
                <p class="label">您的评分，我们的动力</p>
                <p class="num">{{userNum}}人已点评</p>
            </div>
            <div class="content-bottom">
                <p class="label">点评</p>
                <!-- <div class="rate">
                  <van-rate v-model="rateValue" :size="24" color="#ffd21e" void-icon="star" readonly allow-half void-color="#eee"/>
                </div> -->
                <div class="starbox" :style="{'width':`${size*total}vw`,'height':`${size}vw`}" style="position:relative;">
                    <!-- 暗星星 -->
                    <div class="star_box1" style="white-space: nowrap;overflow: hidden;position: absolute;">
                      <svg-icon icon-class="pfwjx1" class-name="pfwjx1" :style="{'width':`${size}vw`,'height':`${size}vw`}" v-for="star in total" :key="star+'grey'"></svg-icon>
                    </div>
                    <!-- 亮星星 -->
                    <div class="star_box2" style="white-space: nowrap;overflow: hidden;position: absolute;" 
                    :style="{'width':`${rateValue / total * 100}%`}">
                        <svg-icon icon-class="pfwjx" class-name="pfwjx" :style="{'width':`${size}vw`,'height':`${size}vw`}" v-for="star in total" :key="star+'bright'"></svg-icon>
                    </div>
                </div>
                <p class="text">{{rateValue}}分</p>
            </div>
          </div>
        </div>
        <div class="buttom">
            <div class="button" v-if="!issubmit"  @click="handleEvaluation">评分</div>
        </div>
        
        <!-- 评分弹窗 -->
        <scoreDialog v-if="scoreDialogVisible.show" :scoreDialogVisible="scoreDialogVisible" :info="scoreInfo" :issubmit="issubmit" />
    </div>
</template>

<script>
export default {
    name:'platformEvaluation',
    data(){
        return {
          star:'4.6',//总分
          total:5,//星星总数
          size:7,//尺寸
          rateValue:0,
          userNum:0,
          scoreDialogVisible:{
              show: false,
          },
          scoreInfo:{
              title:'评分',
              name:'',
              scoreArr:[]
          }, // 评分需要的参数
          issubmit:false,
          userId:''
        }
    },
    async created(){
        await this.findUser();
        await this.findMyBranchEvaluation()
    },
    methods:{
      // 获取当前评分
      async findMyBranchEvaluation(){
          await this.$api.usercenter.findMyBranchEvaluation({}).then((res) => {
              if(res.data){
                  this.rateValue = res.data.avgScore;
                  this.userNum = res.data.userNum;
                  this.scoreInfo.name = res.data.branchName;
                  this.scoreInfo.scoreArr = [];
                  this.issubmit = res.data.branchEvaluationVoList.length ? true : false;
                  res.data.branchEvaluationVoList.length && res.data.branchEvaluationVoList.forEach(item => {
                    this.scoreInfo.scoreArr.push({
                        label:item.evaluationItemName,
                        count:item.score
                    })
                  })
              }
          })
      },
      // 获取用户信息
       async findUser() {
          await this.$api.usercenter.findUser().then((res) => {
            if (res.code == 0 && res.data) {
              this.userId = res.data.id;
            }
          })
        },
        handleEvaluation(){
            if(!this.scoreInfo.scoreArr.length){
              this.scoreInfo.scoreArr = [
                  {
                    label:'服务态度',
                    count: 0,
                  },
                  {
                    label:'服务能力',
                    count: 0,
                  },
                  {
                    label:'服务效率',
                    count: 0,
                  }
              ]
            }
            
            this.scoreDialogVisible.show = true;
        },
        async evaluateCourse(arr){
            console.log(arr,'arr==');
            const data = [
                {
                  evaluationItem:'SERVICE_ATTITUDE',
                  evaluationItemName:'服务态度',
                  score:arr[0].count,
                },
                {
                  evaluationItem:'SERVICE_ABILITY',
                  evaluationItemName:'服务能力',
                  score:arr[1].count,
                },
                {
                  evaluationItem:'SERVICE_EFFICIENCY',
                  evaluationItemName:'服务效率',
                  score:arr[2].count,
                }
            ]
            await this.$api.usercenter.branchEvaluationSave({ data }).then(res => {
                if(res.data){
                  this.clickclose()
                  this.findMyBranchEvaluation();
                }
            })
        },
        /**
         * 评分
         */
         clickclose(){
            this.scoreDialogVisible.show=false;
            this.$forceUpdate;
        },
        onClickLeft() {
            this.$router.go(-1);
        },
    }
}
</script>

<style lang="less" scoped>
.platformEvaluation{
    background-color: #F7F7F7;
    min-height: 100vh;
    .content-box{
        padding: 32px 30px 0;
        .content{
            background-color: #fff;
            border-radius: 16px;
            padding: 28px 28px 0;
            box-sizing: border-box;
            .content-top{
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-bottom: 32px;
                border-bottom: 1px solid #E4E5E6;
                .label{
                  font-size: 32px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  line-height: 32px;
                }
                .num{
                  font-size: 24px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  line-height: 24px;
                }
            }
            .content-bottom{
                display: flex;
                align-items: center;
                padding: 42px 0 55px;
                .label{
                  font-size: 28px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #333333;
                  line-height: 28px;
                  margin-right: 32px;
                }
                .text{
                    margin-left: 24px;
                    font-size: 28px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #333333;
                    line-height: 28px;
                    margin-top: 0;
                }

            }
        }
    }
    .buttom{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 112px;
        background: #FFFFFF;
        box-shadow: inset 0px 1px 0px 0px #EAEAEA;
        padding: 12px 30px;
        box-sizing: border-box;
        .button{  
          width: 100%;
          height: 88px;
          background: linear-gradient(136deg, #227FFF 0%, #316FFF 100%);
          border-radius: 44px;
          text-align: center;
          line-height: 88px;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
        }
    }
}
</style>